import { CONSTANT } from "@/helpers/constant"
import { auth, salesforce } from "@/router/middleware"

export default {
  path: "/",
  component: () => import("@/views/sales-force/SalesForceIndex.vue"),
  meta: {
    middleware: [auth, salesforce],
  },
  children: [
    {
      path: CONSTANT.ROUTE.PATH.DASHBOARD_SALES_FORCE,
      name: CONSTANT.ROUTE.NAME.DASHBOARD_SALES_FORCE,
      component: () => import("@/views/sales-force/SalesForceDashboard.vue"),
    },
    {
      path: CONSTANT.ROUTE.PATH.SALES_FORCE_SETTINGS_INDEX,
      name: CONSTANT.ROUTE.NAME.SALES_FORCE_SETTINGS_INDEX,
      component: () => import("@/views/sales-force/SalesForceSettings.vue"),
    },
    {
      path: CONSTANT.ROUTE.PATH.SALES_FORCE_JC_FILTER_GROUPS,
      name: CONSTANT.ROUTE.NAME.SALES_FORCE_JC_FILTER_GROUPS,
      component: () => import("@/views/sales-force/jersey-configurator/JcFilterGroupManagement.vue"),
    },
    {
      path: CONSTANT.ROUTE.PATH.SALES_FORCE_JC_FILTER_GROUP_DETAIL,
      name: CONSTANT.ROUTE.NAME.SALES_FORCE_JC_FILTER_GROUP_DETAIL,
      component: () => import("@/views/sales-force/jersey-configurator/JcFilterGroupDetail.vue"),
    },
    {
      path: CONSTANT.ROUTE.PATH.SALES_FORCE_JC_DISPLAY_GROUPS,
      name: CONSTANT.ROUTE.NAME.SALES_FORCE_JC_DISPLAY_GROUPS,
      component: () => import("@/views/sales-force/jersey-configurator/JcDisplayGroupManagement.vue"),
    },
    {
      path: CONSTANT.ROUTE.PATH.SALES_FORCE_CUSTOMER_DATA_INDEX,
      name: CONSTANT.ROUTE.NAME.SALES_FORCE_CUSTOMER_DATA_INDEX,
      redirect: CONSTANT.ROUTE.PATH.SALES_FORCE_CUSTOMER_DATA,
      component: () => import("@/views/sales-force/CustomerDataIndex.vue"),
      children: [
        {
          path: CONSTANT.ROUTE.PATH.SALES_FORCE_CUSTOMER_DATA,
          name: CONSTANT.ROUTE.NAME.SALES_FORCE_CUSTOMER_DATA,
          redirect: CONSTANT.ROUTE.PATH.SALES_FORCE_CUSTOMER_DATA_BASE,
          component: () => import("@/views/sales-force/customer-data/CustomerData.vue"),
          children: [
            {
              path: CONSTANT.ROUTE.PATH.SALES_FORCE_CUSTOMER_DATA_CREATE,
              name: CONSTANT.ROUTE.NAME.SALES_FORCE_CUSTOMER_DATA_CREATE,
              component: () => import("@/views/sales-force/customer-data/CustomerDataGeneralIndex.vue"),
            },
            {
              path: CONSTANT.ROUTE.PATH.SALES_FORCE_CUSTOMER_DATA_BASE,
              name: CONSTANT.ROUTE.NAME.SALES_FORCE_CUSTOMER_DATA_BASE,
              component: () => import("@/views/sales-force/customer-data/CustomerDataGeneralIndex.vue"),
            },
            {
              path: CONSTANT.ROUTE.PATH.SALES_FORCE_CUSTOMER_DATA_ADDRESSES,
              name: CONSTANT.ROUTE.NAME.SALES_FORCE_CUSTOMER_DATA_ADDRESSES,
              component: () => import("@/views/sales-force/customer-data/CustomerDataAddressesV2.vue"),
            },
            {
              path: CONSTANT.ROUTE.PATH.SALES_FORCE_CUSTOMER_DATA_ORDER,
              name: CONSTANT.ROUTE.NAME.SALES_FORCE_CUSTOMER_DATA_ORDER,
              component: () => import("@/views/sales-force/customer-data/CustomerDataOrders.vue"),
            },
            {
              path: CONSTANT.ROUTE.PATH.SALES_FORCE_CUSTOMER_DATA_ORDER_DETAIL,
              name: CONSTANT.ROUTE.NAME.SALES_FORCE_CUSTOMER_DATA_ORDER_DETAIL,
              component: () => import("@/views/sales-force/customer-data/CustomerDataOrderView.vue"),
            },
            {
              path: CONSTANT.ROUTE.PATH.SALES_FORCE_CUSTOMER_DATA_DOCUMENTS,
              name: CONSTANT.ROUTE.NAME.SALES_FORCE_CUSTOMER_DATA_DOCUMENTS,
              component: () => import("@/views/sales-force/customer-data/CustomerDataDocuments.vue"),
            },
          ],
        },
        {
          path: CONSTANT.ROUTE.PATH.SALES_FORCE_ORDER_CATALOGUE,
          name: CONSTANT.ROUTE.NAME.SALES_FORCE_ORDER_CATALOGUE,
          component: () => import("@/views/sales-force/OrderCatalogue.vue"),
        },
        // {
        //   path: CONSTANT.ROUTE.PATH.SALES_FORCE_PRODUCT_RANGE,
        //   name: CONSTANT.ROUTE.NAME.SALES_FORCE_PRODUCT_RANGE,
        //   component: () => import("@/views/sales-force/ProductRange.vue"),
        // },
        // {
        //   path: CONSTANT.ROUTE.PATH.SALES_FORCE_PRODUCT_RANGE_DETAILS,
        //   name: CONSTANT.ROUTE.NAME.SALES_FORCE_PRODUCT_RANGE_DETAILS,
        //   component: () => import("@/views/sales-force/ProductRangeDetail.vue"),
        // },
        {
          path: CONSTANT.ROUTE.PATH.SALES_FORCE_PRODUCT_RANGE,
          name: CONSTANT.ROUTE.NAME.SALES_FORCE_PRODUCT_RANGE,
          component: () => import("@/views/sales-force/product-range-v2/ProductRangeIndex.vue"),
        },
        {
          path: CONSTANT.ROUTE.PATH.SALES_FORCE_PRODUCT_RANGE_DETAILS,
          name: CONSTANT.ROUTE.NAME.SALES_FORCE_PRODUCT_RANGE_DETAILS,
          component: () => import("@/views/sales-force/product-range-v2/ProductRangeDetail.vue"),
        },
        {
          path: CONSTANT.ROUTE.PATH.SALES_FORCE_BUNDLE,
          name: CONSTANT.ROUTE.NAME.SALES_FORCE_BUNDLE,
          component: () => import("@/views/sales-force/bundle/BundleIndex.vue"),
        },
        {
          path: CONSTANT.ROUTE.PATH.SALES_FORCE_BUNDLE_CREATE,
          name: CONSTANT.ROUTE.NAME.SALES_FORCE_BUNDLE_CREATE,
          component: () => import("@/views/sales-force/bundle/BundleDetail.vue"),
        },
        {
          path: CONSTANT.ROUTE.PATH.SALES_FORCE_BUNDLE_DETAILS,
          name: CONSTANT.ROUTE.NAME.SALES_FORCE_BUNDLE_DETAILS,
          component: () => import("@/views/sales-force/bundle/BundleDetail.vue"),
        },
        // {
        //   path: CONSTANT.ROUTE.PATH.SALES_FORCE_OFFER_OVERVIEW,
        //   name: CONSTANT.ROUTE.NAME.SALES_FORCE_OFFER_OVERVIEW,
        //   component: () => import("@/views/sales-force/OfferOverview.vue"),
        // },
        // {
        //   path: CONSTANT.ROUTE.PATH.SALES_FORCE_OFFER_DETAIL,
        //   name: CONSTANT.ROUTE.NAME.SALES_FORCE_OFFER_DETAIL,
        //   component: () => import("@/views/sales-force/OfferDetail.vue"),
        // },

        {
          path: CONSTANT.ROUTE.PATH.SALES_FORCE_OFFER_OVERVIEW_V2,
          name: CONSTANT.ROUTE.NAME.SALES_FORCE_OFFER_OVERVIEW_V2,
          component: () => import("@/views/sales-force/offer-v2/OfferIndex.vue"),
        },
        {
          path: CONSTANT.ROUTE.PATH.SALES_FORCE_OFFER_EDIT_GENERAL,
          name: CONSTANT.ROUTE.NAME.SALES_FORCE_OFFER_EDIT_GENERAL,
          component: () => import("@/views/sales-force/offer-v2/OfferGeneral.vue"),
        },

        {
          path: CONSTANT.ROUTE.PATH.SALES_FORCE_PDF_CATALOGUE,
          name: CONSTANT.ROUTE.NAME.SALES_FORCE_PDF_CATALOGUE,
          component: () => import("@/views/sales-force/pdf-catalogue/PDFCatalogue.vue"),
        },
        {
          path: CONSTANT.ROUTE.PATH.SALES_FORCE_PDF_CATALOGUE_DETAILS,
          name: CONSTANT.ROUTE.NAME.SALES_FORCE_PDF_CATALOGUE_DETAILS,
          component: () => import("@/views/sales-force/pdf-catalogue/PDFCatalogueDetail.vue"),
        },
        {
          path: CONSTANT.ROUTE.PATH.SALES_FORCE_JERSEY_CONFIGURATOR,
          name: CONSTANT.ROUTE.NAME.SALES_FORCE_JERSEY_CONFIGURATOR,
          component: () => import("@/views/sales-force/jersey-configurator/JerseyConfiguratorOverview.vue"),
        },
        {
          path: CONSTANT.ROUTE.PATH.SALES_FORCE_JERSEY_CONFIGURATOR_CREATE,
          name: CONSTANT.ROUTE.NAME.SALES_FORCE_JERSEY_CONFIGURATOR_CREATE,
          component: () => import("@/views/sales-force/jersey-configurator/JerseyConfiguratorBasicInfo.vue"),
        },
        {
          path: CONSTANT.ROUTE.PATH.SALES_FORCE_JERSEY_CONFIGURATOR_EDIT,
          name: CONSTANT.ROUTE.NAME.SALES_FORCE_JERSEY_CONFIGURATOR_EDIT,
          redirect: CONSTANT.ROUTE.PATH.SALES_FORCE_JERSEY_CONFIGURATOR_BASIC_INFO,
          component: () => import("@/views/sales-force/jersey-configurator/JerseyConfiguratorEdit.vue"),
          children: [
            {
              path: CONSTANT.ROUTE.PATH.SALES_FORCE_JERSEY_CONFIGURATOR_BASIC_INFO,
              name: CONSTANT.ROUTE.NAME.SALES_FORCE_JERSEY_CONFIGURATOR_BASIC_INFO,
              component: () => import("@/views/sales-force/jersey-configurator/JerseyConfiguratorBasicInfo.vue"),
            },
            {
              path: CONSTANT.ROUTE.PATH.SALES_FORCE_JERSEY_CONFIGURATOR_PRODUCTS,
              name: CONSTANT.ROUTE.NAME.SALES_FORCE_JERSEY_CONFIGURATOR_PRODUCTS,
              component: () => import("@/views/sales-force/jersey-configurator/JerseyConfiguratorProduct.vue"),
            },
            {
              path: CONSTANT.ROUTE.PATH.SALES_FORCE_JERSEY_CONFIGURATOR_ADVANCE_SETTINGS,
              name: CONSTANT.ROUTE.NAME.SALES_FORCE_JERSEY_CONFIGURATOR_ADVANCE_SETTINGS,
              component: () => import("@/views/sales-force/jersey-configurator/JerseyConfiguratorAdvanceSettings.vue"),
            },
            {
              path: CONSTANT.ROUTE.PATH.SALES_FORCE_JERSEY_CONFIGURATOR_DEPLOYMENT,
              name: CONSTANT.ROUTE.NAME.SALES_FORCE_JERSEY_CONFIGURATOR_DEPLOYMENT,
              component: () => import("@/views/sales-force/jersey-configurator/JerseyConfiguratorDeployment.vue"),
            },
          ],
        },
        {
          path: CONSTANT.ROUTE.PATH.SALES_FORCE_USER_PERMISSION_INDEX,
          name: CONSTANT.ROUTE.NAME.SALES_FORCE_USER_PERMISSION_INDEX,
          component: () => import("@/views/sales-force/user-permission/UsersPermissionsIndex.vue"),
        },
        {
          path: CONSTANT.ROUTE.PATH.SALES_FORCE_USER_PERMISSION_USER_CREATE,
          name: CONSTANT.ROUTE.NAME.SALES_FORCE_USER_PERMISSION_USER_CREATE,
          component: () => import("@/views/sales-force/user-permission/UserForm.vue"),
          props: true,
        },
        {
          path: CONSTANT.ROUTE.PATH.SALES_FORCE_USER_PERMISSION_USER_EDIT,
          name: CONSTANT.ROUTE.NAME.SALES_FORCE_USER_PERMISSION_USER_EDIT,
          component: () => import("@/views/sales-force/user-permission/UserForm.vue"),
          props: true,
        },
        {
          path: CONSTANT.ROUTE.PATH.SALES_FORCE_USER_PERMISSION_ROLE_CREATE,
          name: CONSTANT.ROUTE.NAME.SALES_FORCE_USER_PERMISSION_ROLE_CREATE,
          component: () => import("@/views/sales-force/user-permission/RoleForm.vue"),
          props: true,
        },
        {
          path: CONSTANT.ROUTE.PATH.SALES_FORCE_USER_PERMISSION_ROLE_EDIT,
          name: CONSTANT.ROUTE.NAME.SALES_FORCE_USER_PERMISSION_ROLE_EDIT,
          component: () => import("@/views/sales-force/user-permission/RoleForm.vue"),
          props: true,
        },
        {
          path: CONSTANT.ROUTE.PATH.SALES_FORCE_MEMBERSHIP,
          name: CONSTANT.ROUTE.NAME.SALES_FORCE_MEMBERSHIP,
          component: () => import("@/views/sales-force/membership/SalesForceMembership.vue"),
        },
        {
          path: CONSTANT.ROUTE.PATH.SALES_FORCE_MEMBERSHIP_INVITATION,
          name: CONSTANT.ROUTE.NAME.SALES_FORCE_MEMBERSHIP_INVITATION,
          component: () => import("@/views/sales-force/membership/SalesForceMembershipInvitation.vue"),
        },
      ],
    },
  ],
}
